import React from 'react';

import Modal from '..';
import { CircularProgress, Grid } from '@material-ui/core';

type Props = {
    open: boolean;
    onClose: () => void;
    src: any;
    loading: boolean
};

export default function VideoModal(props: Props) {
    const { onClose, open, src, loading } = props;

    return (
        <Modal
            maxWidth="lg"
            onClose={onClose}
            open={open}
            title={
                <div style={{ textAlign: 'center' }}>
                    <span>ویدئو آموزشی</span>
                </div>
            }
            content={
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        {loading ?
                            <div style={{ width: "1200px", height: "700px", textAlign: "center" }}>
                                <p>لطفا شکیبا باشید</p>
                                <CircularProgress />
                            </div>
                            :
                            <iframe
                                src={src}
                                allowFullScreen={true}
                                width="950"
                                height="650"
                                style={{borderRadius: '20px'}}
                            ></iframe>
                        }
                    </Grid>
                </Grid>
            }
        />
    );
}

VideoModal.defaultProps = {
    open: false,
    onClose: () => null,
    src: "",
    loading: false
};
